import { Button, cn, type ButtonProps } from "@eisox/design-system";

import { Position, type Component } from "../types";

interface CardProps extends Component, ButtonProps {
  children: React.ReactNode;
  defect?: boolean;
}

const Card: React.FC<CardProps> = ({ children, defect, position = Position.TOP, className, ...props }) => (
  <Button
    {...props}
    className={cn(
      "px-2.5 py-1.25 relative w-fit rounded-[5px] border border-solid border-primary-darker-gray bg-primary-white text-base whitespace-nowrap text-primary-dark-blue",
      className,
    )}
  >
    {children}
    {defect !== undefined && (
      <div
        className={cn(
          "size-2.5 absolute rounded-full",
          position === Position.TOP && "top-0 right-0 translate-x-1/2 -translate-y-1/2",
          position === Position.BOTTOM && "right-0 bottom-0 translate-x-1/2 translate-y-1/2",
          defect ? "bg-primary-red" : "bg-primary-green",
        )}
      />
    )}
  </Button>
);

Card.displayName = "Card";

export { Card };
export type { CardProps };
